module.exports = __webpack_public_path__ + "static/diversity-41f8b740a193c87883c9db9731005102.svg";